import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subscription, from } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { SettingsService } from 'src/app/pages/settings/settings.service';
import { UserAssetsService } from 'src/app/pages/user-asset/user-assets.service';
import { WalletService } from 'src/app/pages/wallet/wallet.service';
import { CurrenciesInterface } from 'src/app/shared/interfaces/deposit.interface';
import { CurrencyBalance } from 'src/app/shared/interfaces/wallet.interface';
import { CurrencyValuePipe } from 'src/app/shared/pipes/currency-value.pipe';
import { DataCollectionService } from 'src/app/shared/service/data-collection.service';
import { LayoutService } from 'src/app/shared/service/layout.service';
import { LocalStorageService } from 'src/app/shared/service/localstorage.service';
import { PopupService } from 'src/app/shared/service/popup.service';
import { CurrencyWalletService } from './currency-wallet.service';

@UntilDestroy()
@Component({
  selector: 'app-currency-wallet',
  templateUrl: './currency-wallet.component.html',
  styleUrls: ['./currency-wallet.component.scss'],
})
export class CurrencyWalletComponent implements OnInit {
  logined!: boolean;
  currentCurrencyData?: CurrenciesInterface;
  allCurrencyBalance: CurrencyBalance[] = [];

  /** 頂部標題列用：可見幣種（與 expansion 校準 `currentCurrency$`） */
  visibleCurrencies: CurrenciesInterface[] = [];

  /** 钱包推送的时间 */
  oldTime = 0;

  @ViewChild('amount') amountElement!: ElementRef;
  @Input() onlyBalance: boolean = false;

  constructor(
    private renderer: Renderer2,
    private appService: AppService,
    private userAssetsService: UserAssetsService,
    public localStorageService: LocalStorageService,
    private currencyValuePipe: CurrencyValuePipe,
    private popup: PopupService,
    private layout: LayoutService,
    private settingsService: SettingsService,
    private dataCollectionService: DataCollectionService,
    private walletService: WalletService,
    public currencyWalletService: CurrencyWalletService
  ) {}

  ngOnInit() {
    // 初始化换算、汇率相关
    this.currencyWalletService.initConversion();

    // 订阅当前登录账号信息判断是否已登录
    this.appService.userInfo$.pipe(untilDestroyed(this)).subscribe(v => {
      this.logined = !!v;
      if (this.logined) {
        this.getUserBalance();
        // this.userUid = v?.uid as string;
      }
    });

    this.appService.currencies$.pipe(untilDestroyed(this)).subscribe(list => {
      if (list?.length) {
        this.visibleCurrencies = list.filter(x => x.isVisible);
        this.syncCurrentCurrencyToVisibleList(this.appService.currentCurrency$.value);
      }
    });

    //订阅当前货币
    this.appService.currentCurrency$.pipe(untilDestroyed(this)).subscribe(v => {
      this.syncCurrentCurrencyToVisibleList(v);
    });

    //订阅资产相关的signalr通知，用于更新钱包
    this.appService.assetChanges$
      .pipe(
        filter(v => v.related === 'Wallet'), //关联目标是钱包
        untilDestroyed(this)
      )
      .subscribe(msg => {
        // 如果没有data,说明是手动更新钱包
        if (!msg.data) {
          this.getUserBalance();
          return;
        }
        // 原创需求 开始plinko 投注时，锁住钱包
        if (this.appService.assetChangesLock$.value) {
          return;
        }
        // 对比上一次推送时间，上一次推送时间大于当前，那么不用跟新余额
        if (this.oldTime > (msg.time ?? 0)) return;
        this.oldTime = msg.time ?? 0;
        if (typeof msg.data.Balance == 'number') {
          // 单币种
          const item = this.allCurrencyBalance.find(balanceItem => balanceItem.currency === msg.data?.Currency);
          if (item) {
            if (msg?.type === 'NonStickyBalance') {
              if (msg?.data?.Category === 'SlotGame') {
                item.nsSlotGame!.balance = msg.data.Balance || 0;
              } else {
                item.nsLiveCasino!.balance = msg.data.Balance || 0;
              }
            } else {
              item.balance = msg.data.Balance;

              // 新增需求 赢钱增加动画 只要金额变化是大于 0，那么就需要增加动画效果 msg.data.Amount
              // console.log(msg.data.Amount)
            }
            item.nonStickyBalance = Number(item.balance)
              .add(Number(item?.nsSlotGame?.balance || 0))
              .add(Number(item?.nsLiveCasino?.balance || 0));

            if (msg.data.Amount > 0) {
              const amount = this.currencyValuePipe.transform(msg.data.Amount, msg.data.Currency);
              // this.startUserAnimation(amount)
              this.appService.assetChangesAnimation$.next(amount);
            }
          }
        } else {
          // 多币种更改余额
          const objBalance = msg.data.Balance;
          Object.keys(objBalance || {}).forEach(key => {
            const item = this.allCurrencyBalance.find(balanceItem => balanceItem.currency === key);
            if (item) {
              item.balance = objBalance[key];
              item.nonStickyBalance = Number(objBalance[key] || 0)
                .add(item.nsSlotGame?.currency === key ? item.nsSlotGame?.balance || 0 : 0)
                .add(item.nsLiveCasino?.currency === key ? item.nsLiveCasino?.balance || 0 : 0);
            }
          });
        }
        this.appService.userBalance$.next([...this.allCurrencyBalance]);
      });

    this.appService.userBalance$.pipe(untilDestroyed(this)).subscribe(v => {
      if (v) {
        this.allCurrencyBalance = v;
      }
    });
    this.appService.assetChangesAnimation$.pipe(untilDestroyed(this)).subscribe(v => {
      if (v) {
        this.startUserAnimation(v);
      }
    });

    this.appService.originalAutoBet$.pipe(untilDestroyed(this)).subscribe(v => {
      this.isDiasbled = v;
    });
  }
  /** isShowPlaying 是否展示游戏进行 */
  get isShowPlaying(): boolean {
    return this.appService.isShowTopWalletPalying;
  }

  startUserAnimation(Amount: string) {
    if (!this.amountElement) return;
    const amountElement = this.amountElement.nativeElement as HTMLElement;
    const div = this.renderer.createElement('div');
    div.innerHTML = Amount;
    this.renderer.addClass(div, 'add-amount');
    this.renderer.appendChild(amountElement.parentElement, div);
    const top = amountElement.offsetTop;
    const y = top + 20;
    div.style.top = `${y}px`;
    div.style.opacity = 1;
    let speed = 0;
    let speedop = 1;
    const userTimer = setInterval(() => {
      speed = speed - 0.3;
      speedop = speedop - 0.02;
      div.style.top = `${y + speed}px`;
      div.style.opacity = speedop;
      if (speedop <= 0) {
        clearInterval(userTimer);
        this.renderer.removeChild(amountElement.parentElement, div);
      }
    }, 10);
  }

  /** 更新余额订阅 */
  updateUserbalance$!: Subscription;
  updateMainWallet$!: Subscription;
  // 原创自动投注禁止币种切换后的样式
  isDiasbled: boolean = false;
  /**
   * 更新钱包信息
   */
  getUserBalance() {
    this.updateUserbalance$?.unsubscribe();
    this.updateUserbalance$ = from(this.userAssetsService.getUserbalance()).subscribe(
      (userbalance: CurrencyBalance[]) => {
        if (userbalance.length > 0) {
          this.appService.userBalance$.next(userbalance);
        }
      }
    );
    this.updateMainWallet$?.unsubscribe();
    this.updateMainWallet$ = from(this.userAssetsService.getWalletInfor())
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data) {
          this.appService.mainWalletBalance$.next(data.overviewWallet);
        }
      });
  }

  /**
   * 頂部展示的幣種須落在可見列表內；否則降为 USDT（或第一個可見幣）。
   */
  private syncCurrentCurrencyToVisibleList(meta: CurrenciesInterface | null | undefined): void {
    if (!meta?.currency) return;
    if (!this.visibleCurrencies?.length) {
      this.currentCurrencyData = meta;
      return;
    }

    const matched = this.visibleCurrencies.find(c => c.currency === meta.currency && c.isVisible);
    if (matched) {
      this.currentCurrencyData = matched;
      return;
    }

    const usdt = this.visibleCurrencies.find(c => c.currency === 'USDT' && c.isVisible);
    const fallback = usdt ?? this.visibleCurrencies.find(c => c.isVisible);
    if (!fallback) return;

    this.localStorageService.currentCurrency = fallback.currency;
    if (fallback.currency !== this.appService.currentCurrency$.value?.currency) {
      this.appService.currentCurrency$.next(fallback);
    }
    this.currentCurrencyData = fallback;
  }

  toDeposit(e: Event) {
    if (this.currentCurrencyData) {
      this.walletService.popupOpen(this.currentCurrencyData.currency, 'd-fiat');
    }
    e.stopPropagation();
  }

  /**
   * 立即反應變更的幣種
   *
   * @param v
   */
  receiveSelectItemHeader(v: CurrenciesInterface) {
    this.syncCurrentCurrencyToVisibleList(v);
  }
}
